// extracted by mini-css-extract-plugin
export default {"slideContainer":"_4de1261ffb _6cd17d5f8c _3270c56622","slideImage":"_9ce0ebf244"};